<template>
  <div class="content-container tab-container flex-row">
    <TheLoader :active="loading"/>

    <overlay-scrollbars :options="{ className: 'content-container flex-column os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <section class="content large-padding">

        <div class="grid-x align-items-center">
          <div class="cell auto">
            <h2 class="no-margin">Konsultasjonsrapport</h2>
          </div>

          <div class="cell shrink">
            <div class="grid-x grid-margin-x">
              <div class="cell shrink">
                <a href="javascript:;" @click="print()" class="button action glyph">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg>
                  <span>Skriv ut</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="card large-padding margin-top no-margin-bottom card-background">
          <div class="cell">
              <div class="input-container full-height" :class="{'form-error': errors.has('Konklusjon')}">
                <textarea v-model="form.Konklusjon" name="Konklusjon" rows="30" placeholder="Rapportdetailjer…" v-validate="'required'" :disabled="!isPresenceOwner"></textarea>
                <span class="form-error-label" v-if="errors.has('Konklusjon')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('Konklusjon')}}
                </span>
              </div>
            </div>
        </div>

      </section>
    </overlay-scrollbars>

    <div class="sidebar large right fixed">
      <div class="fixed-container">
        <overlay-scrollbars :options="{ className: 'sidebar-content-container os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
          <fieldset class="card form-line-container">
            <div class="grid-x grid-padding-x">
              <div class="cell">
                <label for="Dato">Dato</label>
                <div class="input-container date" :class="{'form-error': errors.has('Dato')}">
                  <b-datepicker
                    :show-week-number="false"
                    :editable="false"
                    :first-day-of-week="1"
                    v-model="form.Dato"
                    v-validate="'required'"
                    data-vv-validate-on="input"
                    name="Dato"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="Dato"
                    id="Dato"
                    :disabled="!isPresenceOwner"
                  >
                    <button class="button disabled" v-if="!form.Dato" @click.prevent="$refs.Dato.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="form.Dato = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                  <span class="form-error-label" v-if="errors.has('Dato')">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                    {{errors.first('Dato')}}
                  </span>
                </div>
              </div>

              <TheTextInput containerClassName="cell" :disabled="!isPresenceOwner" label="Hvor ble objektet vist frem?" name="Hvor" v-model.trim="form.Hvor" v-validate="'required|max:200'"/>
              <TheTextInput containerClassName="cell" :disabled="!isPresenceOwner" label="Hvem ble konsultert" name="Konsult" v-model.trim="form.Konsult" v-validate="'required|max:200'"/>
              <TheTextInput containerClassName="cell" :disabled="!isPresenceOwner" label="Ansvarlig fra Blomqvist" name="Tilstede" v-model.trim="form.Tilstede" v-validate="'required|max:200'"/>
            </div>

            <div class="grid-x grid-padding-x">
              <div class="cell auto"></div>
              <div class="cell shrink">
                <template v-if="isPresenceOwner">
                  <a href="javascript:;" v-if="$store.getters.isFormSubmittable" @click="handleSubmit()" class="button primary initiate-loading"><span class="button-title">Lagre rapport</span></a>
                  <a href="javascript:;" v-if="$store.getters.isFormProcessing" class="button primary loading"><span class="button-title">Lagrer rapport</span> <span class="loader-spinner"></span></a>
                  <a href="javascript:;" v-if="$store.getters.isFormLoading" class="button primary disabled"><span class="button-title">Lagre rapport</span></a>
                </template>
                <template v-else>
                  <a href="javascript:;" class="button primary disabled"><span class="button-title">Lagre rapport</span></a>
                </template>
              </div>
            </div>
          </fieldset>
        </overlay-scrollbars>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'KundeKontraktObjektTabKonsultasjon',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      form: {
        Objektid: null,
        Dato: null,
        Hvor: '',
        Konsult: '',
        Tilstede: '',
        Konklusjon: ''
      },
      presenceChannelName: null
    }
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  computed: {
    item: function () {
      return this.$store.getters['objektkonsult/item']
    },
    loading: function () {
      return this.$store.getters['objektkonsult/loading']
    },
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    }
  },
  watch: {
    objekt: function () {
      // Set form not submittable
      this.setFormLoading(true)

      this.$store.dispatch('objektkonsult/get', this.objekt.Objektid)
        .then(() => {
          this.setupForm()
        })
        .catch(() => {
          this.setupForm()
        })
    }
  },
  created () {
    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid
  },
  mounted () {
    // Set form not submittable
    this.setFormLoading(true)

    this.$store.dispatch('objektkonsult/get', this.objekt.Objektid)
      .then(() => {
        this.setupForm()
      })
      .catch(() => {
        this.setupForm()
      })
  },
  methods: {
    setupForm: function () {
      if (this.item && this.item.Objektid) {
        // Copy kunde to form
        this.form = this._.cloneDeep(this.item)

        if (this.item.Dato) {
          this.form.Dato = new Date(Date.parse(this.item.Dato))
        }
      } else {
        // Set some data based on logged in user + objekt
        this.form = {
          Objektid: null,
          Dato: null,
          Hvor: '',
          Konsult: '',
          Tilstede: '',
          Konklusjon: ''
        }

        this.form.Objektid = this.objekt.Objektid
        this.form.Tilstede = this.$store.getters.getUser.Brukernavn
        this.form.Kontraktnr = this.objekt.Kontraktnr
        this.form.Lopenr = this.objekt.Lopenr
      }

      this.setFormLoading(false)
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      if (this.form.Konklusjon) {
        this.form.Konklusjon = this.form.Konklusjon.trim()
      }

      let post = this._.clone(this.form)

      if (post.Dato) {
        const df = new Date(Date.parse(post.Dato))
        post.Dato = moment(df).format('YYYY-MM-DD 00:00:00')
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$store.dispatch('objektkonsult/save', post)
              .then((response) => {
                this.$helpers.showSuccessAlert('Rapport er lagret')
                this.setFormProcessing(false)
              })
              .catch((error) => {
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }

                this.setFormProcessing(false)
              })
          }
        })
    },
    print: function () {
      window.print()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabKonsultasjon.vue